export enum CohortTimelineIndexZero {
  Week0Day1 = 1,
  Week0Day7 = 7,
  Week1Day1 = 8,
  Week1Day7 = 14,
  Week2Day1 = 15,
  Week2Day7 = 21,
  Week3Day1 = 22,
  Week3Day7 = 28,
  Week4Day1 = 29,
  Week4Day7 = 35,
  Week5Day1 = 36,
  Week5Day7 = 42,
  Week6Day1 = 43,
  Week6Day7 = 49,
  Week7Day1 = 50,
  Week7Day7 = 56,
  Week8Day1 = 57,
  Week8Day7 = 63,
  Week9Day1 = 64,
  Week9Day7 = 70,
  Week10Day1 = 71,
  Week10Day7 = 77,
  Week11Day1 = 78,
  Week11Day7 = 84,
  Week12Day1 = 85,
  Week12Day7 = 91,
  Week13Day1 = 92,
  Week13Day7 = 98,
  Week14Day1 = 99,
  Week14Day7 = 105,
  FirstExerciseDay = Week1Day1,
  LastExerciseDay = Week12Day7,
}
